import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import * as Apollo from '@apollo/client';
var defaultOptions = {};
export var GetIntercomUserJwtDocument = {
  kind: 'Document',
  definitions: [{
    kind: 'OperationDefinition',
    operation: 'query',
    name: {
      kind: 'Name',
      value: 'GetIntercomUserJWT'
    },
    selectionSet: {
      kind: 'SelectionSet',
      selections: [{
        kind: 'Field',
        name: {
          kind: 'Name',
          value: 'intercom'
        },
        selectionSet: {
          kind: 'SelectionSet',
          selections: [{
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'get_jwt_encode'
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{
                kind: 'InlineFragment',
                typeCondition: {
                  kind: 'NamedType',
                  name: {
                    kind: 'Name',
                    value: 'JWTResponseType'
                  }
                },
                selectionSet: {
                  kind: 'SelectionSet',
                  selections: [{
                    kind: 'Field',
                    name: {
                      kind: 'Name',
                      value: 'jwt_encode'
                    }
                  }]
                }
              }, {
                kind: 'InlineFragment',
                typeCondition: {
                  kind: 'NamedType',
                  name: {
                    kind: 'Name',
                    value: 'JWTResponseTypeError'
                  }
                },
                selectionSet: {
                  kind: 'SelectionSet',
                  selections: [{
                    kind: 'Field',
                    name: {
                      kind: 'Name',
                      value: 'error_message'
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
};

/**
 * __useGetIntercomUserJwtQuery__
 *
 * To run a query within a React component, call `useGetIntercomUserJwtQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntercomUserJwtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntercomUserJwtQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIntercomUserJwtQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useQuery(GetIntercomUserJwtDocument, options);
}
export function useGetIntercomUserJwtLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(GetIntercomUserJwtDocument, options);
}